/**
 * AllSet — line the desktop dropdown links up under their parent menu item.
 *
 * Horizon's submenu is a full-width strip whose link column sits in grid column 1,
 * i.e. the far left of the page, however far along the bar the parent item is.
 * The strip stays full width; we measure where the parent's title starts and hand
 * that distance to CSS as `--custom-submenu-offset` (see `custom.css`, "Desktop
 * dropdown"), which shifts the link column across.
 *
 * Measured on pointer/focus entry rather than once, so it stays right after font
 * loading, resizes and header re-renders. Event delegation on `document` means
 * nothing needs re-binding when Horizon swaps the header markup.
 */
const ITEM = '.header-menu .menu-list__list-item';

function align(item) {
  const title = item.querySelector(':scope > .menu-list__trigger .menu-list__link-title');
  const grid = item.querySelector(':scope > .menu-list__submenu .mega-menu__grid');
  if (!title || !grid) return;

  // Align to where the title's text starts: the span carries `padding-inline: var(--gap-sm)`.
  // The offset is applied as padding, which never moves the grid's own left edge.
  const textLeft = title.getBoundingClientRect().left + parseFloat(getComputedStyle(title).paddingInlineStart);
  const offset = textLeft - grid.getBoundingClientRect().left;

  grid.style.setProperty('--custom-submenu-offset', `${Math.max(0, Math.round(offset))}px`);
}

function onEnter(event) {
  const item = event.target instanceof Element ? event.target.closest(ITEM) : null;
  if (item) align(item);
}

document.addEventListener('pointerover', onEnter, { passive: true });
document.addEventListener('focusin', onEnter);
window.addEventListener('resize', () => document.querySelectorAll(ITEM).forEach(align), { passive: true });
document.querySelectorAll(ITEM).forEach(align);
